import { useEffect, useState } from 'react';
import { hitAudiencies } from 'components/corporatiu/Audiencies/audiencies-datalayer';
import { useRouter } from 'next/router';
import { useButlletins } from 'hooks/corporatiu/useButlletins';
import { useUser } from 'hooks/useUser';
import { useModal } from 'hooks/corporatiu/useModal';
import Boto from 'components/corporatiu/Boto';
import AvisButlletins from 'components/corporatiu/Butlletins/AvisButlletins';
import ModalNoLogat from 'components/corporatiu/ModalNoLogat';
import clsx from 'clsx';
import styles from './botosubscripcio.module.scss';

const _hasSubscribed = (id, items) => {
    return items?.some((item) => item?.info_contingut?.id?.toString() === id.toString());
};

const BotoSubscripcio = (props) => {
    const { id, titol } = props;
    const { setModal } = useModal();
    const [activeSubscripcio, setActiveSubscripcio] = useState(false);
    const { isAuthenticated, accessToken, state: userState } = useUser();
    const router = useRouter();
    const { itemsSubscripcionsButlletins, addSubscripcioButlleti, isLoading } = useButlletins();
    const textBoto = activeSubscripcio ? 'Subscripció activa' : "Subscriu-t'hi";
    const iconaBoto = activeSubscripcio ? 'check_no_contorn' : null;

    const stylesBoto = clsx({
        [styles.boto]: true,
        [styles.subscripcioActiva]: activeSubscripcio,
        [styles.disabled]: isLoading
    });

    const altaButlleti = async () => {
        const status = await addSubscripcioButlleti(id);
        setModal(<AvisButlletins tipus='alta' estat={status} />, {
            className: styles.modalAlta,
            mode: 'flotant'
        });
    };

    const handleOnClick = async () => {
        if (!isAuthenticated || !accessToken) {
            setModal(
                <ModalNoLogat
                    optionsSign={{
                        namespace: '[web]butlletins-alta-butlleti',
                        addSubscripcioButlletiId: id
                    }}
                />,
                { className: styles.modalBg, closeOnClickOutside: true }
            );
            return;
        }
        if (activeSubscripcio) {
            setModal(<AvisButlletins tipus='baixa' id={id} titol={titol} />, {
                className: styles.modalBg,
                closeOnClickOutside: true
            });
        } else {
            hitAudiencies('scClicBoto', { URL: window.location.href, identificadorClic: `Alta butlletí: ${titol}` });
            altaButlleti();
        }
    };

    useEffect(() => {
        if (itemsSubscripcionsButlletins.itemsLoaded) {
            setActiveSubscripcio(_hasSubscribed(id, itemsSubscripcionsButlletins?.items));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [itemsSubscripcionsButlletins, router.asPath]);

    useEffect(() => {
        if (
            userState &&
            userState.router === router.pathname &&
            userState.namespace === '[web]butlletins-alta-butlleti' &&
            userState.addSubscripcioButlletiId === id
        ) {
            altaButlleti();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userState]);

    return (
        <Boto
            tag='button'
            estil='ple3cat100'
            className={stylesBoto}
            text={textBoto}
            icona={iconaBoto}
            iconaInline={true}
            mida='18'
            isIconaDreta={false}
            onClick={handleOnClick}
        />
    );
};

export default BotoSubscripcio;
